export default __webpack_public_path__ + "static/Egress-Square-24993bdf1b43f368a70bef913c7f52db.jpg";